import React, { useEffect, useState } from 'react';

import { Link, useNavigate, useParams } from 'react-router-dom';

import Swal from 'sweetalert2';

import { FaBuilding } from 'react-icons/fa';

import Title from '../../Components/Admin/Title';

import useFetchApi from '../../hooks/useFetchApi';
import { MANDAP_DATA_EDIT_ADMIN_URL, MANDAP_DATA_UPDATE_ADMIN_URL } from '../../utils/Constant';
import { authHeaders } from '../../utils/api';

function EditMandap() {

    const { id } = useParams();

    const navigate = useNavigate();

    // =========================
    // FETCH DATA
    // =========================

    const url = MANDAP_DATA_EDIT_ADMIN_URL(id);

    // const { data } = useFetchApi({
    //     url,
    //     dataKey: null
    // });

    // const { data } = useFetchApi({
    //     url: url,
    //     dataKey: null,
    //     token: localStorage.getItem("admin_token"), // ✅ auth token
    // });

    const { data } = useFetchApi({
        url: url,
        dataKey: null,
        authType: 'admin'// ✅ auth token
    });

    // =========================
    // FORM DATA
    // =========================

    const [formData, setFormData] = useState({
        name: '',
        booking_amount: '',
        user_fee: '',
        status: '1',
    });

    // =========================
    // ERRORS
    // =========================

    const [errors, setErrors] = useState({});

    // =========================
    // SET DATA
    // =========================

    useEffect(() => {

        if (data?.id) {

            setFormData({
                name: data.name || '',
                booking_amount: data.booking_amount || '',
                user_fee: data.user_fee || '',
                status: String(data.status ?? 1),
            });
        }

    }, [data]);

    // =========================
    // VALIDATION
    // =========================

    const validateErrors = (name, value) => {

        let error = '';

        // required
        if (
            value === '' ||
            value === null ||
            value === undefined
        ) {

            error = 'This field is required';
        }

        // number validation
        if (
            (name === 'booking_amount' ||
                name === 'user_fee') &&
            value
        ) {

            if (!/^\d+$/.test(value)) {

                error = 'Only numbers allowed';
            }
        }

        return error;
    };

    // =========================
    // HANDLE CHANGE
    // =========================

    const handleChange = (e) => {

        const { name, value } = e.target;

        const updatedData = {
            ...formData,
            [name]: value,
        };

        setFormData(updatedData);

        const error = validateErrors(
            name,
            value
        );

        setErrors((prev) => ({
            ...prev,
            [name]: error,
        }));
    };

    // =========================
    // FORM VALIDATE
    // =========================

    const formValidate = () => {

        const tempErrors = {};

        Object.keys(formData).forEach((key) => {

            const error = validateErrors(
                key,
                formData[key]
            );

            if (error) {

                tempErrors[key] = error;
            }
        });

        setErrors(tempErrors);

        return Object.keys(tempErrors).length === 0;
    };

    // =========================
    // SUBMIT
    // =========================

    const handleSubmit = async (e) => {

        e.preventDefault();

        const isValid = formValidate();

        if (!isValid) return;

        try {

            // const res = await fetch(
            //     MANDAP_DATA_UPDATE_ADMIN_URL(id),
            //     {
            //         method: 'PUT',

            //         headers: {
            //             'Content-Type': 'application/json',
            //             Accept: 'application/json',
            //         },

            //         body: JSON.stringify(formData),
            //     }
            // );

            const res = await fetch(
                MANDAP_DATA_UPDATE_ADMIN_URL(id),
                {
                    method: "PUT",
                    headers: authHeaders(),
                    body: JSON.stringify(formData),
                }
            );

            const result = await res.json();

            // validation error
            if (!res.ok) {

                if (result.errors) {

                    const formattedErrors = {};

                    Object.keys(result.errors).forEach((key) => {

                        formattedErrors[key] = result.errors[key][0];
                    });

                    setErrors(formattedErrors);
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Oops!',
                    text: result.message || 'Something went wrong',
                });

                return;
            }

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: result.message,
                timer: 2000,
                showConfirmButton: false,
            });

            setTimeout(() => {

                navigate('/admin/mandaps');

            }, 2000);

        } catch (error) {

            console.log(error);

            Swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: 'Something went wrong',
            });
        }
    };

    return (
        <>

            <Title
                icon={FaBuilding}
                title='Edit Mandap'
            />

            <div className="bg-white rounded shadow-lg mt-5">

                <h4
                    className="
                        text-lg
                        p-4
                        font-semibold
                        border-b
                        flex
                        justify-between
                        items-center
                    "
                >

                    Edit Mandap

                    <Link
                        to="/admin/mandaps"
                        className="
                            btn
                            btn-accent
                            btn-sm
                            text-white
                            shadow-md
                        "
                    >
                        Back
                    </Link>

                </h4>

                <form
                    onSubmit={handleSubmit}
                    className="p-4"
                >

                    <div className="grid grid-cols-2 gap-5">

                        {/* Name */}
                        <div>

                            <label className="block text-sm mb-1">
                                Mandap Name
                            </label>

                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className={`
                                    input
                                    input-bordered
                                    w-full
                                    ${errors.name ? 'border-error' : ''}
                                `}
                            />

                            {errors.name && (
                                <p className="text-red-500 text-xs mt-1">
                                    {errors.name}
                                </p>
                            )}

                        </div>

                        {/* Booking Amount */}
                        <div>

                            <label className="block text-sm mb-1">
                                Booking Amount
                            </label>

                            <input
                                type="number"
                                name="booking_amount"
                                value={formData.booking_amount}
                                onChange={handleChange}
                                className={`
                                    input
                                    input-bordered
                                    w-full
                                    ${errors.booking_amount ? 'border-error' : ''}
                                `}
                            />

                            {errors.booking_amount && (
                                <p className="text-red-500 text-xs mt-1">
                                    {errors.booking_amount}
                                </p>
                            )}

                        </div>

                        {/* User Fee */}
                        <div>

                            <label className="block text-sm mb-1">
                                User Fee
                            </label>

                            <input
                                type="number"
                                name="user_fee"
                                value={formData.user_fee}
                                onChange={handleChange}
                                className={`
                                    input
                                    input-bordered
                                    w-full
                                    ${errors.user_fee ? 'border-error' : ''}
                                `}
                            />

                            {errors.user_fee && (
                                <p className="text-red-500 text-xs mt-1">
                                    {errors.user_fee}
                                </p>
                            )}

                        </div>

                        {/* Status */}
                        <div>

                            <label className="block text-sm mb-1">
                                Status
                            </label>

                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                className={`
                                    select
                                    select-bordered
                                    w-full
                                    ${errors.status ? 'border-error' : ''}
                                `}
                            >

                                <option value="1">
                                    Active
                                </option>

                                <option value="0">
                                    Inactive
                                </option>

                            </select>

                            {errors.status && (
                                <p className="text-red-500 text-xs mt-1">
                                    {errors.status}
                                </p>
                            )}

                        </div>

                    </div>

                    {/* Button */}
                    <div className="mt-5">

                        <button
                            type="submit"
                            className="
                                btn
                                btn-primary
                                text-white
                            "
                        >
                            Update Mandap
                        </button>

                    </div>

                </form>

            </div>

        </>
    );
}

export default EditMandap;